import React from 'react';
import { getDefaultformFields } from '../utilities/form-utilities';
import { getConfig } from '../../../helpers';
import APIManager from '../../../utilities/api-manager';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));
function getMarketoAPIVariant(variant: string): string {
    return getConfig(`components.request-a-trial.marketoAPIVariant.${variant}`, 'Mobility') as string;
}

const getSubmissionBody = (
    productName: string,
    data: RequestATrialState,
) => {
    const body: RATMobilityFormRequest = {
        FirstName: data.FirstName,
        LastName: data.LastName,
        Country: data.Country as string,
        State: data.State ? String(data.State) : '',
        City: data.City,
        Email: data.Email,
        Phone: data.Phone,
        Company: data.Company,
        MarketoIndustry: data.CompanyType as string,
        JobFunction: data.JobFunction as string,
        OriginatingSourceURL: window.location.href,
        OriginatingNotes: data.OtherInterest,
        GDPRConsentQuestion: String(data.HasUserConsent),
        ProductInterest: data.InterestArea,
        UTMSource: 'Marketplace',
        CallToActionType: 'Request for Information'
    };
    return body;
};

const getUTMParamString = (utmParameters: UTMParameters) => {
    let utmString = '';
    if (utmParameters.utmSource) {
        utmString = `${utmString}utm_source=${utmParameters.utmSource}&`;
    }
    if (utmParameters.utmMedium) {
        utmString = `${utmString}utm_medium=${utmParameters.utmMedium}&`;
    }
    if (utmParameters.utmCampaign) {
        utmString = `${utmString}utm_campaign=${utmParameters.utmCampaign}&`;
    }
    if (utmParameters.utmTerm) {
        utmString = `${utmString}utm_term=${utmParameters.utmTerm}&`;
    }
    if (utmParameters.utmContent) {
        utmString = `${utmString}utm_content=${utmParameters.utmContent}&`;
    }
    if (utmString.length > 0) utmString = utmString.substring(0, utmString.length - 1);
    return utmString;
};

const submitForm = (
    requestBody: RATMobilityFormRequest,
    cb: () => void,
    error: (error: string) => void
) => {

    APIManager.submitLeadToMobility(requestBody).then(response => {
        if (response.data) {
            cb();
            return;
        }
        error('Mobility request  failed');
    }).catch(() => error('Mobility request  failed'));
};

function RequestTrialMobilityForm(props: RequestATrialFormProps) {
    const { productName = '', variant, productVariant, titleText, ratVariant } = props;

    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        const requestBody = getSubmissionBody(productName, data);
        requestBody.ProductInterest = data.InterestArea
            ? data.InterestArea.replace(/,/g, ';')
            : '';
        requestBody.OriginatingNotes = productName ? `${productName} : ${data.OtherInterest}` : data.OtherInterest;
        requestBody.Variant = getMarketoAPIVariant(variant || '');
        submitForm(requestBody, cb, error);
    };
    const defaultFormTextFields = getDefaultformFields();
    return (
        <RequestTrialForm onSubmitForm={onSubmit} formTextFields={defaultFormTextFields} productVariant={productVariant} titleText={titleText} ratVariant={ratVariant} />
    );
}

export default React.memo(RequestTrialMobilityForm);
